import CardSystem from '../CardSystem';
import GameObject from '../../../GameObject/GameObject';
import Animator from '../../../Prototype/Animator';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import BaseCard from 'Prototype/Level/Card/BaseCard';
import { RenderSystemEvent } from 'System/Render/RenderSystem';
import { RevealJokerPreBooster } from '../../Animation/Clip/RevealJokerPreBooster';
import { AnimationClipTask } from 'Utility/Task/AnimationClipTask';

export default async function RevealJokerPreBoosterAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): Promise<void> {
    const cards: BaseCard[] = taskData.cards.map(cardID => system.getCardByID(cardID));
    const jokers: BaseCard[] = taskData.jokers.map((cardID: string) => system.getCardByID(cardID));
    const animator = GameObject.Instantiate(Animator);
    system.animator.addChild(animator);
    system.scene.emit(RenderSystemEvent.BRING_TO_FRONT, system.animator);

    system.taskQueue.queueNext(
        new AnimationClipTask(
            new RevealJokerPreBooster(animator, {
                system,
                jokers,
                cards,
            })
        )
    );
}
